module.exports = __webpack_public_path__ + "03_glasses_brown.69c6f7b3.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/okuta/son/layer4/03_glasses_brown.png
// module id = DN0G
// module chunks = 0